export const heroCommunitiesSelector = state => state.heroCommunities.get('heroCommunities');
export const heroCommunitiesIsLoadingSelector = state => state.heroCommunities.get('isLoading');
export const heroCommunitiesHasOwnCommunity = state => state.heroCommunities.get('hasOwnCommunity');
